export const UPDATE_LYRICS_VIEWED = 'UPDATE_LYRICS_VIEWED';
